export default async function getMenuData() {
  return [
    {
      key: 'reportsworkorders',
      icon: 'fe fe-clipboard',
      url: '/reports/workorder',
      permission: 'report_workorder',
    },
    {
      key: 'reportsCustomWorkOrders',
      icon: 'fe fe-clipboard',
      url: '/reports/custom-workorders',
      permission: 'report_workorder',
    },
    {
      key: 'workorderstatusReport',
      icon: 'fe fe-clipboard',
      url: '/reports/workorderstatusReport',
      permission: 'report_workorder',
    },
    {
      key: 'seperator',
    },
    {
      key: 'reportsworkordersByCustomerStatus',
      icon: 'fe fe-clipboard',
      url: '/reports/workorderbycustomerstatus',
      permission: 'report_workorder',
    },
    {
      key: 'seperator',
    },
    {
      key: 'reportsinventory',
      icon: 'fe fe-hard-drive',
      url: '/reports/inventory',
      permission: 'report_inventory',
    },
    {
      key: 'reporttechnician',
      icon: 'fe fe-git-branch',
      url: '/reports/technician',
      permission: 'report_technician',
    },
    {
      key: 'maintenanceReport',
      icon: 'fe fe-file',
      url: '/reports/preventivemaintenance',
      permission: 'report_workorder',
    },
    {
      key: 'clinBudgetReport',
      icon: 'fe fe-file',
      url: '/reports/clinBudgetReport',
      permission: 'report_budget',
    },
  ]
}
